module.exports = __webpack_public_path__ + "img/logo@2x.b40c8421.png";